import jwtDecode from 'jwt-decode';
import * as loglevel from 'loglevel';
import {initAsync, terminateAsync} from 'langyan';

import authApi from '@/api/auth';
import userApi from '@/api/user';
import keyApi from '@/api/key';
import roleApi from '@/api/role';
import router from '@/router/router';
import sysConfig from '@/configs/sys';
import {subjectSchoolSystem} from '@/configs/keys';

export default {
  async initApp({commit, state}, payload) {
    if (!window.indexedDB) {
      // TODO do other browser check, and think a better way to alert
      alert('Sorry~ Your browser does not support indexedDB.');
      router.push({name: 'Signin'});
      return;
    }

    let token = sessionStorage.getItem('token');
    if (!token) {
      if (router.app._route.meta.auth !== false) {
        router.push({name: 'Signin'});
      }
      return;
    }

    try {
      let res = await authApi.validateToken(token);
      if (!res.success) {
        throw new Error('Token expired.');
      }
    } catch (e) {
      log.error('validate token failed.', e);
      sessionStorage.clear();
      router.push({name: 'Signin'});
      return;
    }
    let userid = jwtDecode(token)._id;
    commit('updateUserId', userid);
    router.push({name: 'Home'});
  },

  async initAppData({commit, state, dispatch}, payload) {
    commit('updateAppLoading', true);

    let results = await Promise.all([
      userApi.getProfileByID(state.userid),
      roleApi.getRoles(),
      keyApi.getKeysByType('subject'),
      keyApi.getKeysByType('schoolsystem')
    ]);

    results.forEach((r, index) => {
      // TODO remove r.susscee statement when backend bug has been fixed.
      if (!r.success && !r.susscee) {
        throw new Error('無法取得數據資料😱');
      }
    });

    // turn role array into object
    let roles = results[1].roles.reduce((accumulator, currentValue) => {
      accumulator[currentValue._id] = currentValue;
      return accumulator;
    }, {});

    // asssemble subjects data: add schoolSystems relation property.
    results[2].keys.forEach(s => s.schoolSystems = subjectSchoolSystem[s._id]);
    // turn subject array into object
    let subjects = results[2].keys.reduce((accumulator, currentValue) => {
      accumulator[currentValue._id] = currentValue;
      return accumulator;
    }, {});

    // turn schoolSystem array into object
    let schoolSystems = results[3].keys.reduce((accumulator, currentValue) => {
      accumulator[currentValue._id] = currentValue;
      return accumulator;
    }, {});

    let profile = results[0].profile;
    commit('updateProfile', profile);
    commit('updateRoles', roles);
    commit('updateSubjects', subjects);
    commit('updateSchoolSystems', schoolSystems);

    let mySchoolSystems = [].concat(profile.metadata['學制']);
    commit('teacher/updateFilter', {schoolSystem: mySchoolSystems[0]});

    await dispatch('initLangyan');

    commit('updateAppLoading', false);
  },

  async initLangyan({commit, state, dispatch}, payload) {
    let options = {
      userId: state.userid,
      userName: state.profile.username,
      token: sessionStorage.getItem('token'),
      webSyncServerUrl: sysConfig.webSyncServerUrl,
      iceLinkServerAddress: sysConfig.iceLinkServerAddress,
      chatServiceUrl: sysConfig.chatServiceUrl,
      fudaoServiceUrl: sysConfig.fudaoServiceUrl,
      log: loglevel
    };

    console.groupCollapsed('init langyan');
    await initAsync(options);
    console.groupEnd();

    console.groupCollapsed('init langyan servcie');
    await dispatch('user/initUserService');
    await dispatch('chat/initChatService');
    await dispatch('fudao/initFudaoService');
    console.groupEnd();
  },

  async signup({commit, state}, user) {
    let res;
    try {
      let validateRes = await userApi.validateEmail(user.email);
      // success === true means this email has already been used
      if (validateRes.success) {
        throw new Error('信箱重複');
      }
      res = await userApi.signup(user);
    } catch (e) {
      throw e;
    }

    if (res.success) {
      return;
    }

    let errMsg;
    let errCode = res.msg ? res.msg.code : null;
    switch (errCode) {
      case 11000:
        errMsg = '此帳號已有人使用，請重新輸入';
        break;
      default:
        errMsg = '註冊失敗';
    }
    throw new Error(errMsg);
  },

  async signin({commit, state}, data) {
    let res;
    try {
      res = await authApi.signin(data);
    } catch (e) {
      throw e;
    }

    if (!res.success) {
      throw new Error('使用者帳號密碼錯誤');
    }

    sessionStorage.setItem('token', res.token);
    commit('updateUserId', res.userid);
    router.push({name: 'Home'});
  },

  async signout({commit, state}) {
    commit('updateAppLoading', true);

    console.groupCollapsed('terminate langyan');
    await terminateAsync();
    console.groupEnd();

    sessionStorage.clear();
    // TODO need a better way to reset store.
    commit('updateProfile', null);
    commit('updateUserId', null);

    commit('alert/reset');
    commit('chat/reset');
    commit('fudao/reset');
    commit('teacher/reset');
    commit('user/reset');
    commit('whiteboard/reset');

    commit('updateAppLoading', false);
    router.push({name: 'Signin'});
  },

  async resetPassword({commit, state}, email) {
    let res = await userApi.resetPassword(email);
    if (!res.success) {
      throw new Error('您所輸入的電子郵件有誤，請重新輸入');
    }
  }
};
